import styled from "styled-components";
import { ClockComponentDefaultBox } from "./clock.component.default.box";

export const ClockComponentSICisBox = styled(ClockComponentDefaultBox)`
    letter-spacing: 0.4px;
`;